import React from 'react';

export default (props) =>
<svg className={`logo ${props.className}`}>
  <g>
    <path className="logo__path logo--bottom" d="M 0 80 H 120" strokeWidth="3" />
    <path className="logo__path logo--left__lower" d="M 60 50 L 0 80" strokeWidth="3" />
    <path className="logo__path logo--left__upper" d="M 60 0 L 0 80" strokeWidth="3" />
    <path className="logo__path logo--right__lower" d="M 60 50 L 120 80" strokeWidth="3" />
    <path className="logo__path logo--right__upper" d="M 60 0 L 120 80" strokeWidth="3" />
    <path className="logo__path logo--middle" d="M 60 50 V 0" strokeWidth="3" />
  </g>
</svg>


// WEBPACK FOOTER //
// ./src/images/francis_logo.js